<template>
  <div>
    <div
      v-if="loading"
      class="btn-more"
      @click.prevent.stop="$emit('click')"
    >
      <small>
        <strong class="mr-2"><slot name="loading">Loading</slot></strong>
        <font-awesome-icon
          icon="spinner"
          spin
        />
      </small>
    </div>
    <div
      v-else
      class="btn-more"
      @click.prevent.stop="$emit('click')"
    >
      <small>
        <strong class="mr-2"><slot>{{ label }}</slot></strong>
        <font-awesome-icon
          v-if="caret"
          icon="caret-down"
        />
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonMore',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'View more',
    },
    caret: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-more{
    text-align: center;
    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }
}
</style>
